import React, { useState } from 'react';
import dateFormat from 'dateformat';

import getDaysListForMonth from '@stencil/date-utils/src/getDaysListForMonth';
import modifyDateForDate from '@stencil/date-utils/src/modifyDateForDate';
import getMonthDifferenceBetweenTwoDates from '@stencil/date-utils/src/getMonthDifferenceBetweenTwoDates';
import formatPrice from '@ibibo/format-price';

import * as S from './dcalendar.styles';

interface IMonthsViewProps {
  renderDateItem: Function;
  dateConfigToBeDisplayed: Date;
}

export const MonthView = (props: IMonthsViewProps) => {
  const { renderDateItem, dateConfigToBeDisplayed } = props;
  const dateConfigForMonth = new Date(dateConfigToBeDisplayed);
  const daysList = getDaysListForMonth(dateConfigForMonth);

  return (
    <>
      {daysList.map((item, index) =>
        renderDateItem({
          value: item,
          dateObj: (item && modifyDateForDate(dateConfigForMonth, item)) || null,
          index
        })
      )}
    </>
  );
};

function useCalendarView({
  dateConfigForMonthToBeDisplayedFromProps,
  minDateAllowed,
  maxDateAllowed
}) {
  const [dateConfigForMonthToBeDisplayed, setDateConfigForMonthToBeDisplayed] = useState(
    dateConfigForMonthToBeDisplayedFromProps
  );

  const hideLeftArrow =
    getMonthDifferenceBetweenTwoDates(minDateAllowed, dateConfigForMonthToBeDisplayed) === 0;

  const hideRightArrow =
    getMonthDifferenceBetweenTwoDates(dateConfigForMonthToBeDisplayed, maxDateAllowed) === 0;

  const leftArrowClickHandler = () => {
    if (hideLeftArrow) return;
    dateConfigForMonthToBeDisplayed.setMonth(dateConfigForMonthToBeDisplayed.getMonth() - 1);
    setDateConfigForMonthToBeDisplayed(new Date(dateConfigForMonthToBeDisplayed));
  };

  const rightArrowClickHandler = () => {
    if (hideRightArrow) return;
    dateConfigForMonthToBeDisplayed.setMonth(dateConfigForMonthToBeDisplayed.getMonth() + 1);
    setDateConfigForMonthToBeDisplayed(new Date(dateConfigForMonthToBeDisplayed));
  };

  return [
    hideLeftArrow,
    hideRightArrow,
    leftArrowClickHandler,
    rightArrowClickHandler,
    dateConfigForMonthToBeDisplayed
  ];
}

interface ICalendarViewProps {
  renderDateItem: Function;
  dateConfigForMonthToBeDisplayed: Date;
  minPriceOfMonth: number;
  cheapestMonth;
  monthName: string;
  minDateAllowed: Date;
  maxDateAllowed: Date;
  extendedComponent?: Function;
  // onNextPrevClick?: Function;
}

export const CalendarView = (props: ICalendarViewProps) => {
  const {
    renderDateItem,
    dateConfigForMonthToBeDisplayed: dateConfigForMonthToBeDisplayedFromProps,
    minPriceOfMonth,
    cheapestMonth,
    monthName,
    minDateAllowed,
    maxDateAllowed,
    extendedComponent
    // onNextPrevClick
  } = props;

  const tempDateObjToBeUsedForMonthToBeDisplayedArg = new Date(
    dateConfigForMonthToBeDisplayedFromProps
  );
  tempDateObjToBeUsedForMonthToBeDisplayedArg.setDate(1);

  const [
    hideLeftArrow,
    hideRightArrow,
    leftArrowClickHandler,
    rightArrowClickHandler,
    dateConfigForMonthToBeDisplayed
  ] = useCalendarView({
    dateConfigForMonthToBeDisplayedFromProps: tempDateObjToBeUsedForMonthToBeDisplayedArg,
    minDateAllowed,
    maxDateAllowed
  });

  return (
    <>
      <S.CalMonth>
        {monthName && (
          <p className="f500 blueCnt font14 marginB10 txtCenter posRel">
            {monthName}{' '}
            {minPriceOfMonth && minPriceOfMonth !== Infinity ? (
              <span
                className={'monthlyPrice ' + (cheapestMonth === monthName ? 'cheapestTag' : '')}
              >
                {formatPrice(minPriceOfMonth)}
              </span>
            ) : null}
          </p>
        )}
      </S.CalMonth>
      <S.DateWrapDiv>
        <MonthView
          renderDateItem={renderDateItem}
          dateConfigToBeDisplayed={dateConfigForMonthToBeDisplayed}
        />
      </S.DateWrapDiv>

      {extendedComponent && extendedComponent(dateConfigForMonthToBeDisplayed)}
    </>
  );
};
